module.exports = __webpack_public_path__ + "static/assets/bfbdb5cd538a608d47373ec2ecdfdbfb.png";